import React, { useEffect } from 'react';
import { supabase } from '../lib/supabase';

/**
 * Componente di emergenza per chiudere il popup se Supabase ci redireziona
 * accidentalmente alla home dell'app invece che alla rotta di callback.
 */
export const PopupCloser: React.FC = () => {
  useEffect(() => {
    const checkAndClose = async () => {
      // Non agire se siamo sulla rotta dedicata di callback
      if (window.location.pathname.startsWith('/auth/callback')) {
        return;
      }

      // Un popup ha window.opener popolato oppure un nome specifico
      const isPopup = window.name === 'oauth_popup' || (window.opener && window.opener !== window) || window.location.hash.includes('access_token');
      if (!isPopup) return;

      // Proviamo a recuperare la sessione più volte se non è subito disponibile
      let attempts = 0;
      const maxAttempts = 10;
      
      const interval = setInterval(async () => {
        attempts++;
        const { data: { session } } = await supabase.auth.getSession();
        
        if (session) {
          clearInterval(interval);
          
          // Estrai eventuali token Google in extremis
          const providerToken = localStorage.getItem('temp_google_access_token') || 
                               sessionStorage.getItem('temp_google_access_token') || 
                               localStorage.getItem('google_access_token') || 
                               sessionStorage.getItem('google_access_token');
          const providerRefreshToken = localStorage.getItem('temp_google_refresh_token') || 
                                      sessionStorage.getItem('temp_google_refresh_token') || 
                                      localStorage.getItem('google_refresh_token') || 
                                      sessionStorage.getItem('google_refresh_token');

          const messageData = {
            type: 'OAUTH_AUTH_SUCCESS',
            session: {
              access_token: session.access_token,
              refresh_token: session.refresh_token,
              provider_token: providerToken || undefined,
              provider_refresh_token: providerRefreshToken || undefined,
            },
            timestamp: Date.now(),
          };

          // postMessage è l'unico modo sicuro tra domini diversi
          if (window.opener) {
            try {
              window.opener.postMessage(messageData, '*');
            } catch (e) {}
          }

          // Fallback per stessa origine
          try {
            const channel = new BroadcastChannel('supabase_auth');
            channel.postMessage(messageData);
          } catch (e) {}
          
          localStorage.setItem('supabase_auth_success', JSON.stringify(messageData));
          
          setTimeout(() => window.close(), 1000);
          
          // Se non si chiude, mostriamo un messaggio
          setTimeout(() => {
            document.body.innerHTML = `
              <div style="background:white;color:black;height:100vh;display:flex;flex-direction:column;align-items:center;justify-content:center;font-family:sans-serif;text-align:center;padding:20px;">
                <h1 style="color:#10b981">Accesso completato!</h1>
                <p>Questa finestra dovrebbe essersi chiusa automaticamente.</p>
                <button onclick="window.close()" style="margin-top:20px;padding:12px 24px;background:#000;color:#fff;border:none;border-radius:8px;cursor:pointer;font-weight:bold;">
                  Chiudi e torna all'App
                </button>
              </div>
            `;
          }, 2000);
        }
        
        if (attempts >= maxAttempts) {
          clearInterval(interval);
        }
      }, 500);
    };

    checkAndClose();
  }, []);

  return null;
};
